<template>
  <main id="mainView" :class="{m: isMobile, t:isTablet}">
    <!-- <img class="top_bg"/> -->
    <header :class="{bg : scroll}" class="main_header">
      <Header></Header>
    </header>
    <div class="main_contents">
      <h1 class="disabled"> STATV </h1>
      <router-view></router-view>
    </div>
    <Footer />
  </main>
</template>
<script>
import Header from "@/views/layout/Header.vue";
import Footer from "@/views/layout/Footer.vue";
import Utils from "@/helpers/utils";

export default {
  name: "Main",
  components: { Header, Footer },
  data() {
    return {
      scroll : false,
      isMobile : false,
      isTablet: false,
    }
  },
  created() {
    // this.handleResize();
    this.isMobile = Utils.isMobile();
  },
  mounted() {
    // if(!Utils.isMobile()) window.addEventListener('resize', this.handleResize);
    // else window.addEventListener('deviceorientation', this.handleResize);
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // if(!Utils.isMobile()) window.removeEventListener('resize', this.handleResize);
    // else window.removeEventListener('deviceorientation', this.handleResize);
    window.removeEventListener('scroll', this.handleScroll);
  },
  watch: {
    '$route'(n) {
      if(_.eq(n.path, "/")) this.scroll = false;
      else this.scroll = true;
    }
  },
  methods: {
    handleScroll(e) {
	  let header = document.querySelector('nav.menu_navigator')
	  header.style.left = `-${window.scrollX | document.documentElement.scrollLeft}px`
      if(_.isEqual(this.$route.path, "/")) {
        if((window.scrollY | document.documentElement.scrollTop) <= 0) {
          this.scroll = false;
        } else {
          this.scroll = true;
        }
	  } 
    },
    handleResize(e) {
      // 모바일 화면 기준 765px
      console.log(window.innerWidth)
      if(window.innerWidth <= Utils.getSize().MOBILE) this.isMobile = true, this.isTablet = false;
      // 1080px 해상도일 때 메뉴 축소 (테블릿)
      // else if(window.innerWidth <= Utils.getSize().TABLET) this.isMobile = false, this.isTablet = true;
      else this.isMobile = false, this.isTablet = false;
      // console.log(`[Main View] isMobile : ${this.isMobile}`);
    }
  },
}
</script>
<style lang="less">
#mainView {
  .main_contents {
    margin: auto;
    width: 100%;
    min-width: 1400px;
    max-width: 1920px;
  }

   &.m {
	   .main_contents {
			min-width: 765px;
	   }
	}
}
</style>